// extracted by mini-css-extract-plugin
export default {"productGrid":"xZ-z","centerLink":"yZ-z","productSection":"zZ-z","item":"AZ-z","ctaButton":"BZ-z"};